import { createContext } from 'react';

const FileSettingsContext = createContext({});

export default FileSettingsContext;
